import { useContext } from 'react';
import MapContext from '../controller/MapProvider';
import { InterfaceContext } from '../model/InterfaceProvider';
import { Tooltip, StandardTooltipWindow } from './Tooltip';
import TEXTS from '../controller/TextVariables';

const MobileMenu = (props) => {
    const { tooltip } = TEXTS.controls.expandCollapse;
    const { openMenu, setOpenMenu } = useContext(InterfaceContext);
    const { map } = useContext(MapContext);
    const { type } = props;
    const tab = type.label.toLowerCase();
    const id = 'expand-collapse';
    if (tab === 'more info') return null;

    const toggleMenu = () => {
        setOpenMenu(!openMenu);
        setTimeout(function () {
            map.updateSize();
        }, 500);
    };
    return (
        <>
            <div id="mobile-menu" onClick={toggleMenu}>
                <Tooltip id={id} tooltip={tooltip} window={<StandardTooltipWindow id={id} text={tooltip} tooltipPlace="bottom" />}>
                    <div className="arrow"></div>
                </Tooltip>
            </div>
        </>
    );
};
export default MobileMenu;
